<template>
  <div v-if="htmlContent" v-html="htmlContent" class="producto"></div>
</template>

<script setup>import { ref, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@vueuse/head'

const route = useRoute()
const htmlContent = ref('')
const product = ref(null)

onMounted(async () => {
  const sku = route.params.sku.toUpperCase()


  const res = await fetch('/products.json')
  const data = await res.json()

  product.value = data.find(p => p.sku === sku)

  if (product.value) {
    useHead({
      title: product.value.title,
      meta: [
        { name: 'description', content: product.value.shortDescription },
        { property: 'og:title', content: product.value.title },
        { property: 'og:description', content: product.value.shortDescription },
      ]
    })
  }

  try {
    const res = await fetch(`/templates/${sku}.html`)
    if (res.ok) {
      htmlContent.value = await res.text()
    } else {
      htmlContent.value = '<p>Opis produktu nie został znaleziony.</p>'
    }
  } catch (e) {
    htmlContent.value = '<p>Błąd ładowania opisu produktu.</p>'
  }

  await nextTick()

  const thumbs = Array.from(document.querySelectorAll('.gallery-thumbs .thumb'))

  window.__lightboxState = {
    thumbs,
    currentIndex: 0
  }

  window.selectImage = (thumb) => {
    const mainImage = document.getElementById('main-image')
    if (mainImage) {
      mainImage.src = thumb.src
    }

    window.__lightboxState.thumbs.forEach((img, i) => {
      img.classList.remove('active')
      if (img === thumb) window.__lightboxState.currentIndex = i
    })
    thumb.classList.add('active')
  }

  window.openLightbox = () => {
    const lightbox = document.getElementById('lightbox')
    const lightboxImg = document.getElementById('lightbox-img')
    const mainImg = document.getElementById('main-image')

    if (lightbox && lightboxImg && mainImg) {
      lightbox.style.display = 'flex'
      lightboxImg.src = mainImg.src

      const currentIndex = window.__lightboxState.thumbs.findIndex(t => t.src === mainImg.src)
      window.__lightboxState.currentIndex = currentIndex !== -1 ? currentIndex : 0
    }
  }

  window.closeLightbox = () => {
    const lightbox = document.getElementById('lightbox')
    const lightboxImg = document.getElementById('lightbox-img')
    if (lightbox && lightboxImg) {
      lightbox.style.display = 'none'
      lightboxImg.src = ''
    }
  }

  window.navigateImage = (direction) => {
    const state = window.__lightboxState
    if (!state.thumbs.length) return

    state.currentIndex += direction
    if (state.currentIndex < 0) state.currentIndex = state.thumbs.length - 1
    if (state.currentIndex >= state.thumbs.length) state.currentIndex = 0

    const nextThumb = state.thumbs[state.currentIndex]
    const lightboxImg = document.getElementById('lightbox-img')
    if (lightboxImg) {
      lightboxImg.src = nextThumb.src
    }

    state.thumbs.forEach(t => t.classList.remove('active'))
    nextThumb.classList.add('active')
  }
})

</script>
